import React from 'react';
import PropTypes from 'prop-types';

const OptionItem = ({ name, displayPrice, className = '' }) => {
	return (
		<li className={className}>
			<div className="d-flex">
				<span className="option-title">{name}</span>
				{displayPrice}
			</div>
		</li>
	);
};

OptionItem.propTypes = {
	name: PropTypes.string.isRequired,
	displayPrice: PropTypes.node,
	className: PropTypes.string.isRequired
};

export default OptionItem;
